var $657a7a1f03941145$exports = {};
$657a7a1f03941145$exports = {
    "dismiss": `Rejeter`
};


export {$657a7a1f03941145$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
